import { Columns2 } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const Columns2Icon = createLucideIcon(Columns2);
